import { scrollLock, scrollUnlock } from 'utils/scrollLock'
import scrollTo from 'utils/scrollTo'
import Observer from 'utils/Observer'

class Nav {
  _state = {
    open: false,
    windowWidth: 0,
    isParallaxReady: false,
    hash: null
  }

  static options = {
    pace: 350,
    mobileWidth: 760
  }

  constructor(element, options = {}) {
    this._element = element
    this._options = { ...options, ...Nav.options }
    this._setWindowSize = this._setWindowSize.bind(this)
    this._setParallaxReady = this._setParallaxReady.bind(this)
    this._handleScrollToHash = this._handleScrollToHash.bind(this)
    this._cacheSelectors()
    this._init()
  }

  _cacheSelectors() {
    this._wrapper = document.querySelector('#wrapper')
    this._toggle = this._element.querySelector('#menu-trigger')
    this._links = [...this._element.querySelectorAll('.nav-list__item-link')]
  }

  _init() {
    this._setWindowSize()
    this._handleHashOnLoad()
    this._addListeners()
    this._observeParallax()
  }

  _observeParallax() {
    Observer.subscribe(this._wrapper, 'parallax_ready', this._setParallaxReady)
  }

  _setParallaxReady() {
    this._state.isParallaxReady = true
    Observer.unsubscribe(
      this._wrapper,
      'parallax_ready',
      this._setParallaxReady
    )
    // eslint-disable-next-line no-unused-expressions
    this._state.hash && this._handleScrollToHash()
  }

  _setWindowSize() {
    this._state.windowWidth = window.innerWidth
  }

  _addListeners() {
    this._toggle.addEventListener('click', () => {
      this._handleMenuToggle()
    })

    this._links.forEach(link => {
      const url = link.getAttribute('href')
      const hash = url.indexOf('#') !== -1 ? url.split('#') : null
      const isIndex =
        location.pathname.indexOf('/news') === -1 &&
        location.pathname.indexOf('/events') === -1

      link.addEventListener('click', e => {
        if (!isIndex || !hash) return
        e.preventDefault()

        this._state.hash = hash
        this._handleMenuToggle()
        this._handleScrollToHash()
      })
    })

    window.addEventListener('resize', this._setWindowSize)
  }

  _handleHashOnLoad() {
    const url = document.location.href
    const hash = url.indexOf('#') !== -1 ? url.split('#') : null
    const isIndex =
      location.pathname.indexOf('/news') === -1 &&
      location.pathname.indexOf('/events') === -1
    if (!isIndex || !hash) return
    window.scrollTo(this._html, 0, 0)
    this._state.hash = hash
  }

  _handleMenuToggle() {
    //eslint-disable-next-line
    !this._state.open ? scrollLock() : scrollUnlock()
    this._element.setAttribute('data-navopen', !this._state.open)
    this._toggle.setAttribute('aria-expanded', !this._state.open)
    this._state.open = !this._state.open
  }

  _handleScrollToHash() {
    const target = document.querySelector(`[id="${this._state.hash[1]}"]`)
    this._state.hash = null
    if (!target) {
      return
    }

    const offset =
      window.innerWidth > this._options.mobileWidth
        ? target.getAttribute('data-offset')
        : target.getAttribute('data-offset-mobile')
    scrollTo(target, parseInt(offset, 10), this._options.pace)
  }
}

export default Nav
